import React from "react";
import { Row, Col } from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <React.Fragment>
        <section className="footer-bg">
          <div className="container">
            <Row>
              <Col lg="4">
                <div className="mb-5">
                  <p className="text-uppercase text-dark footer-title mb-4">
                    Sobre Nosotros
                  </p>
                  <p className="text-muted f-14">
                    Somos una cooperativa de recicladores de oficio que nos
                    dedicamos al manejo integral de los residuos sólidos
                    generando utilidades para mejorar la calidad de vida de los
                    asociados y su familia.
                  </p>
                </div>
              </Col>

              <Col lg="4">
                <Row>
                  <Col lg="12">
                    <div className="mb-5">
                      <p className="text-uppercase text-dark footer-title mb-4">
                        Contacto
                      </p>
                      <ul className="list-unstyled footer-sub-menu">
                        <li className="f-14 ">
                          <a className="text-muted d-flex align-items-center flex-row">
                            <i className="fas fa-phone-alt fa-2x" />
                            <span className="ml-2">
                              312 818 90 30 - 570 05 64
                            </span>
                          </a>
                        </li>

                        <li className="f-14">
                          <a className="text-muted d-flex align-items-center flex-row">
                            <i className="fas fa-map-marker-alt fa-2x" />
                            <span className="ml-2">
                              Kra 15 # 22 -40 del Barrio 12 de Octubre
                              Valledupar - Cesar
                            </span>
                          </a>
                        </li>

                        <li className="f-14">
                          <a className="text-muted d-flex align-items-center flex-row">
                            <i className="far fa-envelope fa-2x" />
                            <span className="ml-2">
                              coorrenacer@hotmail.com
                            </span>
                          </a>
                        </li>

                        <li className="f-14">
                          <a className="text-muted d-flex align-items-center flex-row">
                            <i className="fas fa-envelope fa-2x" />
                            <span className="ml-2">
                              coorrenacervalledupar@gmail.com
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Col>

              <Col lg="4">
                <Row>
                  <Col lg="12">
                    <div className="mb-5">
                      <p className="text-uppercase text-dark footer-title mb-4">
                        Redes sociales
                      </p>
                      <ul className="list-unstyled footer-sub-menu">
                        <li className="f-14 ">
                          <a
                            target="_blank"
                            href="https://www.facebook.com/profile.php?id=100008292829014"
                            className="text-muted d-flex align-items-center flex-row"
                          >
                            <i className="fab fa-facebook fa-2x" />
                            <span className="ml-2">
                              Coorrenacer Reciclaje Organizado
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Footer;
